// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__4vzqH","grid":"Footer_grid__Yb5OK","details":"Footer_details__e4cGM"};